import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment as environmentdynamic} from './environments/environment';

if (environmentdynamic.production) {
  enableProdMode();
}

(function (){
  let tracker = document.createElement('script');
  tracker.type='text/javascript';
  tracker.async=true;
   tracker.src=environmentdynamic.omniture_tracker_url;
  //console.log(environmentdynamic);
  let s =document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(tracker,s);
  (window as any)._satellite = {smartLoad:true};
})();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
